
import {LieferpositionPreisModifikator} from "../../../shoppingcart/js/Warenkorb"


/**
 * @classdesc Ein Einzelexemplar mit Grö0e, Anzahl etc
 * @class
 */
export class EinzelExemplar {
	size    : string;
	amount  :number;
	texts   : ExemplarListenText[];

	constructor(size, amount, texts) {
		this.size = size ;
		this.amount = parseInt(amount, 10);
		this.texts = texts;
	}

	public clone() {
		return new EinzelExemplar(this.size, this.amount, this.texts.map(t=>new ExemplarListenText(t.isFixed, t.value, t.textObjectUUID, t.masterID)))
	}
}
/**
 * @classdesc
 * Speichert die Texte eines ExemplarListenEintrags
 * @class
 * @param {boolean} isFixed		gibt an, ob der Eintrag in allen Exemplaren gleich ist. Vorsicht!
 *								Muss beim Anklicken in der Liste des Lock Symbols überall geändert werden!
 *
 * @param {string} value		TextValue
 * @param {string} UUID			ID des zugehörigen Textobjekts
 * @param {string} masterID
 *
 */
export class ExemplarListenText {
	isFixed : boolean;
	value : string;
	textObjectUUID : string;
	masterID : string;

	constructor(isFixed, value, UUID, masterID) {
		/**
		 * gibt an, ob der Eintrag in allen Exemplaren gleich ist. <strong>Vorsicht!</strong>
		 * Muss beim Anklicken in der Liste des Lock Symbols überall geändert werden!
		 * @member {boolean}
		 */
		this.isFixed = isFixed;
		this.value = value;
		this.textObjectUUID = UUID;
		this.masterID = masterID;
	}
}

export class TextObjectInLieferposition {
	public textInhaltAufEntwurf;
	public nameInEntwurf;
	public hasTackleTwill;
	public berechnungsFeature;
	public isFix;

	constructor(nameInEntwurf, vorbelegung, isFix, hasTackleTwill, berechnungsFeature) {
		this.hasTackleTwill = hasTackleTwill;
		this.berechnungsFeature = berechnungsFeature;
		this.nameInEntwurf = nameInEntwurf;
		this.textInhaltAufEntwurf = vorbelegung;
		this.isFix = isFix;

	}
}

export class LogoObjectInLieferposition {
	public nameInEntwurf;
	public hasTackleTwill;
	public berechnungsFeature;

	constructor(nameInEntwurf, hasTackleTwill, berechnungsFeature) {
		this.nameInEntwurf = nameInEntwurf;
		this.hasTackleTwill = hasTackleTwill;
		this.berechnungsFeature = berechnungsFeature;
	}
}

export class LieferpositionDataStructure {
	auwiProdukt;
	produkt;
	design;
	id;
	name;
	anzExemplare;
	amount;
	preis;
	preisMitRabatt;
	relativRabattzuAbsolutBetrag;
	taxRate;
	taxAmount;
	symbol;
	pfad;
	features;
	warnung;
	exemplare;
	textObjects!:TextObjectInLieferposition[];
	logoObjects!:LogoObjectInLieferposition[];
	possibleSizes;
	sport;
	ordertype;
	productCategory;
	mindestBestellung;
	maximalBestellung;
	artikel;
	artikelLokalisiert;
	artikelGroesse;
	artikelGroesseLokalisiert;
	artikelFarbe;
	bwFarbe;
	artikelFarbeLokalisiert;
	typ;
	preismodifikatoren!:LieferpositionPreisModifikator[];
	artikelID;
	mengenBezeichner;
	rabattgruppen;
	fehlendeRohlingGroessen;
}
